import { styled } from '../../hooks/theme';

export const BoxContainer = styled.div`
  padding: 1rem;
  text-align: center;
`;
